import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun } from '@fortawesome/free-solid-svg-icons/faSun';
import type { IconProps } from '../../types';

export function SunIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Sun',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faSun}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
